import { z } from "zod";

export const modalRushOrderFormSchema = z
  .object({
    validate: z.enum(["validDate", "otherDate"]),
    newDeliveryDate: z.date().optional(),
  })
  .refine(
    (data) => {
      if (data.validate === "otherDate") {
        return (
          data.newDeliveryDate instanceof Date &&
          !Number.isNaN(data.newDeliveryDate.getTime())
        );
      }
      return true;
    },
    {
      message: "rushOrderProposal.errorDeliveryDate",
      path: ["newDeliveryDate"],
    }
  );

export type InferredModalRushOrderSchema = z.infer<
  typeof modalRushOrderFormSchema
>;
